<template>
  <div class="overview-container">
    <!-- 检查用户状态 -->
    <div v-if="showNoDataMessage" class="no-data-container">
            <el-empty
        description="暂无数据，请先选课"
        :image-size="200"
      >
        <el-button type="primary" @click="goToCourseSelection">立即选课</el-button>
      </el-empty>
    </div>

    <!-- 原有内容 -->
    <div v-else>
    <div class="overview-main-row">
      <div class="overview-left">
        <div class="overview-circle">
          <span class="overview-count">{{ totalWrong }}</span>
          <div class="overview-label">未处理错题</div>
        </div>
      </div>
      <div class="overview-right">
        <div class="overview-title-row">
          <div class="overview-title">科目总览</div>
          <el-button class="sort-btn" type="primary" @click="toggleSort">
            {{ sortByPriority ? '默认顺序' : '按错题数量排序' }}
          </el-button>
        </div>
        <div class="subject-list">
          <div
            v-for="subject in sortedSubjects"
            :key="subject.name"
            class="subject-card"
            @click="goToDetail(subject)"
          >
            <div class="subject-name">{{ subject.name }}</div>
            <div class="subject-meta">错题数：{{ subject.count }}</div>
            <!-- <div class="subject-meta">超时：{{ subject.timeout }}</div> -->
          </div>
        </div>
      </div>
    </div>

    <!-- 错题知识点统计区块 -->
    <div class="stat-section">
      <div class="stat-title">错题知识点统计</div>
      <div class="stat-content">
        <div class="stat-list">
          <div class="stat-row" v-for="(item, idx) in knowledgeStats" :key="item.name">
            <span class="stat-num">{{ item.count }}</span>
            <span class="stat-knowledge-name">{{ item.name }}</span>
            <div class="stat-line-chart" :ref="'lineChart' + idx"></div>
            <div class="stat-actions">
              <el-button size="mini" @click="showKnowledgeDetail(item.name)">查询</el-button>
              <el-button size="mini" type="warning" @click="goToWeakKnowledge(item.name)">解析</el-button>
              <el-button size="mini" type="success" @click="goToWeakKnowledge(item.name)">训练</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 知识点错题详情弹窗 -->
    <el-dialog :title="'知识点：' + detailKnowledgeName + ' 的错题列表'" :visible.sync="showDetailDialog" width="600px">
      <el-table v-if="detailQuestions.length" :data="detailQuestions" border size="small">
        <el-table-column prop="content" label="题干" min-width="220" />
        <el-table-column prop="analysis" label="原因" min-width="180" />
      </el-table>
      <div v-else style="text-align:center;color:#888;padding:32px 0;">暂无相关错题</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDetailDialog = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 非知识点错题统计区块 -->
    <!-- <div class="stat-section">
      <div class="stat-title">非知识点错题统计 <span class="stat-subtitle">（图饼式分布）</span></div>
      <div class="stat-content">
        <div class="stat-non-left">
          <div class="stat-non-list">
            <div class="stat-non-row" v-for="item in nonKnowledgeStats" :key="item.name">
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
        <div class="stat-non-center" style="flex-direction:column;align-items:center;">
          <div class="stat-pie-chart" ref="pieChart"></div>
          <div v-if="selectedNonKnowledge" class="stat-non-actions">
            <el-button size="mini" @click="showAllWrongQuestions">查询</el-button>
            <el-button size="mini" type="success" @click="onNonKnowledgeTrain">训练</el-button>
            <span class="stat-non-selected">当前类型：{{ selectedNonKnowledge }}</span>
          </div>
        </div>
      </div>
    </div> -->

    <!-- 非知识点错题详情弹窗 -->
    <el-dialog title="错题列表" :visible.sync="showAllWrongDialog" width="900px">
      <el-table v-if="wrongQuestions.length" :data="wrongQuestions" border size="small">
        <el-table-column prop="content" label="题干" min-width="220" />
        <el-table-column prop="analysis" label="原因" min-width="180" />
      </el-table>
      <div v-else style="text-align:center;color:#888;padding:32px 0;">暂无相关错题</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAllWrongDialog = false">关闭</el-button>
      </span>
    </el-dialog>
    </div>
  </div>
</template>

<script>
import { getStudentWrongQuestions } from '@/api/userbook'
import { studentSelectedCourse } from '@/api/course'
import { getToken } from '@/utils/auth'
import { parseJwt } from '@/utils/jwtUtils'
import * as echarts from 'echarts'

export default {
  name: 'UserbookOverview',
  data() {
    return {
      subjects: [],
      totalWrong: 0,
      allSubjects: [], // 改为空数组，将从API动态获取
      sortByPriority: false,
      knowledgeStats: [], // 由后端数据动态生成
      nonKnowledgeStats: [
        { name: '基本运算不熟练' },
        { name: '读题不仔细' },
        { name: '单位不统一' },
        { name: '问题转化能力弱' },
        { name: '知识迁移能力弱' }
      ],
      wrongQuestions: [], // 保存所有错题原始数据
      showDetailDialog: false,
      detailKnowledgeName: '',
      detailQuestions: [],
      nonKnowledgePieData: [],
      selectedNonKnowledge: '',
      showAllWrongDialog: false,
      showNoDataMessage: false // 控制是否显示暂无数据提示
    }
  },
  computed: {
    sortedSubjects() {
      if (this.sortByPriority) {
        // 按错题数降序
        return [...this.subjects].sort((a, b) => b.count - a.count)
      } else {
        // 按 allSubjects 原始顺序
        return this.subjects
      }
    }
  },
  async created() {
    // 检查用户状态
    this.checkUserStatus()
    await this.fetchUserCourses()
    await this.fetchData()
  },
  mounted() {
    this.renderPieChart()
  },
  methods: {
    // 检查用户状态
    checkUserStatus() {
      try {
        const userInfo = JSON.parse(localStorage.getItem('userInfo'))
        // 如果是学生且mark不为1，显示暂无数据提示
        if (userInfo && userInfo.roleId === 1 && userInfo.mark !== 1) {
          this.showNoDataMessage = true
        } else {
          this.showNoDataMessage = false
        }
      } catch (error) {
        console.error('检查用户状态失败:', error)
        this.showNoDataMessage = false
      }
    },

    // 跳转到选课页面
    goToCourseSelection() {
      this.$router.push('/course/selection')
    },

    // 获取用户选课信息
    async fetchUserCourses() {
      try {
        const token = getToken()
        const userInfo = parseJwt(token)
        const userObj = JSON.parse(userInfo.userInfo)
        const userId = userObj.id

        const res = await studentSelectedCourse(userId)
        if (res && res.code === 1 && res.data) {
          // 从选课数据中提取科目名称
          this.allSubjects = res.data.map(course => course.course_name || course.name).filter(Boolean)
        } else {
          // 如果没有选课数据，使用默认科目
          this.allSubjects = ['数学', '语文', '英语']
        }
      } catch (error) {
        console.error('获取用户选课信息失败:', error)
        // 出错时使用默认科目
        this.allSubjects = ['数学', '语文', '英语']
      }
    },

    async fetchData() {
      const token = getToken()
      const userInfo = parseJwt(token)
      const userObj = JSON.parse(userInfo.userInfo)
      const userId = userObj.id
      const res = await getStudentWrongQuestions(userId)
      const wrongQuestions = res.data || []
      this.wrongQuestions = wrongQuestions
      // 按科目统计错题数
      const subjectMap = {}
      wrongQuestions.forEach(q => {
        const subject = q.suboptions || '未分类'
        if (!subjectMap[subject]) subjectMap[subject] = 0
        subjectMap[subject]++
      })
      // 保证所有科目都显示
      this.subjects = this.allSubjects.map(name => ({
        name,
        count: subjectMap[name] || 0
      }))
      this.totalWrong = wrongQuestions.length
      // 统计知识点（knowledge）去重及数量
      const knowledgeMap = {}
      wrongQuestions.forEach(q => {
        const k = q.knowledge || '未知知识点'
        if (!knowledgeMap[k]) knowledgeMap[k] = 0
        knowledgeMap[k]++
      })
      this.knowledgeStats = Object.keys(knowledgeMap).map(name => ({ name, count: knowledgeMap[name] }))
    },
    goToDetail(subject) {
      this.$router.push({ name: 'UserbookSubjectDetail', params: { subject: subject.name } })
    },
    toggleSort() {
      this.sortByPriority = !this.sortByPriority
    },
    showKnowledgeDetail(knowledgeName) {
      this.detailKnowledgeName = knowledgeName
      this.detailQuestions = this.wrongQuestions.filter(q => q.knowledge === knowledgeName)
      this.showDetailDialog = true
    },
    goToWeakKnowledge(knowledgeName) {
      // 如果没有传入知识点名称，则使用当前选中的知识点
      const knowledge = knowledgeName || this.detailKnowledgeName
      // 使用query参数传递知识点信息
      this.$router.push({
        path: '/weakknowledge/create',
        query: { knowledge: knowledge, autoAnalyze: 'true' }
      })
    },
    renderPieChart() {
      // 随机生成每类的数量
      this.nonKnowledgePieData = this.nonKnowledgeStats.map(item => ({
        name: item.name,
        value: Math.floor(Math.random() * 16) + 5 // 5~20
      }))
      const chartDom = this.$refs.pieChart
      if (!chartDom) return
      const chart = echarts.init(chartDom)
      chart.setOption({
        tooltip: { trigger: 'item' },
        legend: { orient: 'vertical', left: 'left' },
        series: [
          {
            name: '非知识点类型',
            type: 'pie',
            radius: '70%',
            data: this.nonKnowledgePieData,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.3)'
              }
            },
            label: {
              show: false
            },
            labelLine: {
              show: false
            }
          }
        ]
      })
      // 监听点击事件
      chart.on('click', params => {
        this.selectedNonKnowledge = params.name
      })
    },
    onNonKnowledgeQuery() {
      this.$message.info('查询：' + this.selectedNonKnowledge)
      // 这里可实现具体查询逻辑
    },
    onNonKnowledgeTrain() {
      this.$router.push('/weakknowledge/create')
    },
    showAllWrongQuestions() {
      this.showAllWrongDialog = true
    }
  }
}
</script>

<style scoped>
.overview-container {
  padding: 32px;
}
.overview-main-row {
  display: flex;
  min-height: 400px;
  align-items: center;
  justify-content: center;
}
.overview-left {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 320px;
}
.overview-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  min-width: 320px;
}
.overview-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 24px;
}
.overview-title {
  font-size: 2rem;
  font-weight: bold;
  color: #409eff;
}
.sort-btn {
  height: 40px;
}
.subject-list {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
}
.subject-card {
  background: #fff;
  border: 1.5px solid #409eff;
  border-radius: 12px;
  padding: 24px 32px;
  min-width: 180px;
  cursor: pointer;
  transition: box-shadow 0.2s;
}
.subject-card:hover {
  box-shadow: 0 4px 16px rgba(64,158,255,0.15);
}
.subject-name {
  font-size: 1.2rem;
  font-weight: 600;
  color: #f56c6c;
  margin-bottom: 8px;
}
.subject-meta {
  color: #888;
  font-size: 1rem;
}
.overview-circle {
  width: 180px;
  height: 180px;
  border: 4px solid #f56c6c;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #f56c6c;
  font-size: 3rem;
  background: #fff;
  box-shadow: 0 4px 24px 0 rgba(245,108,108,0.08);
}
.overview-label {
  font-size: 1.1rem;
  margin-top: 12px;
}
.stat-section {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 24px 0 rgba(60, 72, 88, 0.08);
  margin: 40px auto 0 auto;
  padding: 28px 32px 18px 32px;
  max-width: 1100px;
}
.stat-title {
  font-size: 1.3rem;
  font-weight: 600;
  color: #409eff;
  margin-bottom: 18px;
}
.stat-subtitle {
  color: #f56c6c;
  font-size: 1rem;
  margin-left: 12px;
}
.stat-content {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}
.stat-left {
  flex: 2;
}
.stat-list {
  display: flex;
  flex-direction: column;
  gap: 18px;
}
.stat-row {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  justify-content: flex-start;
}
.stat-num {
  color: #f56c6c;
  font-size: 1.3rem;
  font-weight: bold;
  width: 36px;
  margin-right: 12px;
  text-align: right;
}
.stat-knowledge-name {
  display: inline-block;
  min-width: 80px;
  color: #2d3a4b;
  font-size: 1.05rem;
  margin-left: 10px;
  font-weight: 500;
}
.stat-line-chart {
  width: 180px;
  height: 36px;
  background: #f4f8fb;
  border-radius: 8px;
  margin-left: 8px;
}
.stat-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 18px;
  align-items: flex-start;
  margin-left: 32px;
}
.stat-actions {
  display: flex;
  gap: 8px;
  margin-left: auto;
}
.stat-non-left, .stat-non-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 18px;
  align-items: flex-end;
  justify-content: center;
}
.stat-non-center {
  flex: 2;
  display: flex;
  align-items: center;
  justify-content: center;
}
.stat-pie-chart {
  width: 220px;
  height: 220px;
  background: #f4f8fb;
  border-radius: 50%;
}
.stat-non-list {
  width: 100%;
}
.stat-non-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.stat-non-actions {
  margin-top: 18px;
  display: flex;
  align-items: center;
  gap: 12px;
}
.stat-non-selected {
  color: #409eff;
  font-size: 1rem;
  margin-left: 10px;
}
@media (max-width: 900px) {
  .overview-main-row {
    flex-direction: column;
    align-items: stretch;
  }
  .overview-left, .overview-right {
    min-width: 0;
    width: 100%;
    justify-content: center;
  }
  .overview-right {
    align-items: center;
  }
  .subject-list {
    justify-content: center;
  }
  .stat-section {
    max-width: 98vw;
    padding: 16px 4vw 12px 4vw;
  }
  .stat-content {
    flex-direction: column;
    gap: 18px;
  }
  .stat-right, .stat-non-left, .stat-non-right, .stat-non-center {
    align-items: center;
    margin: 0;
  }
}

/* 弹窗标题字体变大 */
::v-deep .el-dialog__title {
  font-size: 1.4rem;
  font-weight: bold;
}

/* 表格整体字体变大 */
::v-deep .el-table {
  font-size: 1.1rem;
}

/* 表头字体变大 */
::v-deep .el-table th {
  font-size: 1.15rem;
  font-weight: 600;
}

/* 单元格字体变大 */
::v-deep .el-table td {
  font-size: 1.08rem;
}

.no-data-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  flex-direction: column;
}
</style>
